import React, { Fragment, useState } from "react";
import { DeleteModal, ActivationModal } from "../Modals";
// custom hook
import useModuleActions from "hooks/useModuleActions";
import { SingleRowAction } from ".";
import { usePageType } from "hooks";

const RowActions = ({
  cellProps,
  cellProps: {
    row: { original: row },
  },
  onDelete,
  onActivate,
  onClickUpdate,
  onClickView,
  onClickStatus,
  onClickLog,
  onClickCopy,
  onClickPrint,
  subModuleId,
  removeUpdatePermission,
}) => {
  const { isViewPage } = usePageType();
  //extract the  actions permissions from the custom hook
  const {
    isUpdatePermission,
    isSoftDeletePermission,
    isActivatePermission,
    isLogFilePermission,
    isDeactivatePermission,
    isBlackListPermission,
    isWhiteListPermission,
    isUserActivityPermission,
    isCopyPermission,
    isViewPermission,
    isPrintPermission,
  } = useModuleActions(subModuleId && subModuleId);

  // states

  // to toggle the delete modal
  const [isDeleteModal, setIsDeleteModal] = useState(false);

  // to toggle the activation modal
  const [isActivationModal, setIsActivationModal] = useState(false);

  // open delete modal
  const onClickDelete = () => {
    setIsDeleteModal(true);
  };

  // open activation modal
  const onClickActivate = () => {
    setIsActivationModal(true);
  };

  return (
    !isViewPage && (
      <Fragment>
        <div className="d-flex gap-2">
          {/* View icon */}

          {isViewPermission && (
            <SingleRowAction
              onClick={onClickView}
              iconClass="mdi mdi-eye"
              actionName={isViewPermission?.name || "View"}
              record={row}
            />
          )}

          {/* Edit icon */}

          {isUpdatePermission && !removeUpdatePermission && (
            <SingleRowAction
              onClick={onClickUpdate}
              color="text-primary"
              // iconClass="mdi mdi-pencil"
              iconClass="mdi mdi-eye"
              actionName={isUpdatePermission?.name}
              record={row}
            />
          )}

          {/* Deactivate Icon */}

          {isDeactivatePermission && row?.is_active === 1 && (
            <SingleRowAction
              onClick={onClickActivate}
              color="text-info"
              iconClass="mdi mdi-checkbox-marked-circle"
              actionName={isDeactivatePermission?.name}
              record={row}
            />
          )}

          {/* Activate Icon */}

          {isActivatePermission && row?.is_active === 0 && (
            <SingleRowAction
              onClick={onClickActivate}
              color="text-danger"
              iconClass="mdi mdi-checkbox-marked-circle"
              actionName={isActivatePermission?.name}
              record={row}
            />
          )}

          {/* Delete Icon */}

          {isSoftDeletePermission && (
            <SingleRowAction
              onClick={onClickDelete}
              color="text-danger"
              iconClass="mdi mdi mdi-close"
              actionName={isSoftDeletePermission?.name}
              record={row}
            />
          )}

          {/* log history icon */}

          {isLogFilePermission && (
            <SingleRowAction
              onClick={onClickLog}
              // color="text-danger"
              iconClass="mdi mdi-history"
              actionName={isLogFilePermission?.name}
              record={row}
            />
          )}

          {isPrintPermission && (
            <SingleRowAction
              onClick={onClickPrint}
              // color="text-danger"
              iconClass="mdi mdi-cloud-print-outline"
              actionName={isPrintPermission?.name || "print contract"}
              record={row}
            />
          )}

          {/* User Activity  icon */}

          {isUserActivityPermission && (
            <SingleRowAction
              to={`/users/${row?.id}/activity`}
              target="_blank"
              iconClass="mdi mdi-account-search"
              actionName={isUserActivityPermission?.name}
              record={row}
            />
          )}

          {/* Black List icon */}

          {isBlackListPermission &&
            (row?.status?.id === 116 || !row?.status) && (
              <SingleRowAction
                onClick={onClickStatus}
                iconClass="mdi mdi-tooltip-remove"
                actionName={isBlackListPermission?.name}
                record={row}
              />
            )}

          {/* White List icon */}

          {isWhiteListPermission && row?.status?.id === 115 && (
            <SingleRowAction
              onClick={onClickStatus}
              color="text-danger"
              iconClass="mdi mdi-tooltip-check"
              actionName={isWhiteListPermission?.name}
              record={row}
            />
          )}

          {/* Copy (clone) icon */}

          {isCopyPermission && (
            <SingleRowAction
              onClick={onClickCopy}
              iconClass="mdi mdi-content-copy"
              actionName={isCopyPermission?.name || "Copy"}
              record={row}
            />
          )}
        </div>

        <DeleteModal
          show={isDeleteModal}
          onDeleteClick={() => {
            onDelete();
            setIsDeleteModal(false);
          }}
          onCloseClick={() => setIsDeleteModal(false)}
        />

        <ActivationModal
          show={isActivationModal}
          record={row}
          setIsActivationModal={setIsActivationModal}
          onConfirmClick={() => {
            onActivate();
            setIsActivationModal(false);
          }}
          onCloseClick={() => setIsActivationModal(false)}
        />
      </Fragment>
    )
  );
};

export default RowActions;
